import React, { useRef } from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { Cropper } from 'react-cropper'
import 'estilo/cropper/cropper.css'

const ModalCropper = ({ visible, onHide, image, onSave, croppedConfig }) => {

    const cropperRef = useRef(null)

    // Função para salvar a imagem cortada
    const handleSave = () => {
        if (cropperRef.current) {

            const config = {
                width: 96,
                height: 96,
                imageSmoothingQuality: 'high',
                ...croppedConfig
            }

            const cropper = cropperRef.current.cropper

            cropper.getCroppedCanvas(config).toBlob((blob) => {
                const croppedUrl = URL.createObjectURL(blob)
                onSave(blob, croppedUrl)
                onHide()
            })
        }
    }

    const handleCropperReady = () => {

        const cropper = cropperRef.current.cropper
        const width = 200
        const height = 200

        // Aplica a seleção inicial de 100x100 no centro
        const containerData = cropper.getContainerData()
        const centerX = (containerData.width - width) / 2
        const centerY = (containerData.height - height) / 2

        cropper.setCropBoxData({
            left: centerX,
            top: centerY,
            width,
            height,
        })

    }

    // Rodapé do Modal
    const renderFooter = () => (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={onHide} className="p-button-text" />
            <Button label="Salvar" icon="pi pi-check" onClick={handleSave} />
        </div>
    )

    return (
        <Dialog
            header="Editar Imagem"
            visible={visible}
            className='col-12 md:col-6 lg:col-6 xl:col-6'
            // style={{ maxWidth: '50vw' }}
            footer={renderFooter()}
            onHide={onHide}
        >
            <div className="flex justify-content-center">
                {image && (
                    <Cropper
                        src={image}
                        style={{ height: 400, width: '100%' }}
                        initialAspectRatio={1 / 1}
                        aspectRatio={1} // Define proporção exs: {16/9} ou {NaN}
                        guides={true}
                        cropBoxResizable={true}
                        autoCropArea={1}
                        viewMode={1}
                        background={false}
                        responsive={true}
                        ref={cropperRef}
                        ready={handleCropperReady}
                    />
                )}
            </div>
        </Dialog>
    )
}

export default ModalCropper
